import styled from '@emotion/styled';
import torus from '@/assets/pricing/torus.jpg';
import sardine from '@/assets/pricing/sardine.jpg';
import foreguardian from '@/assets/pricing/foreguardian.png';

const cases = [
  {
    title: '이상한 연구소의 토러스 등 3개',
    org: '거창수학체험센터',
    image: torus,
    alt: '이상한 연구소의 토러스 대표 이미지'
  },
  {
    title: '정어리 도둑을 찾아라!',
    org: '트메',
    image: sardine,
    alt: '정어리 도둑을 찾아라! 대표 이미지'
  },
  {
    title: '도와줘요! 포레가디언!',
    org: '군위군청소년수련원',
    image: foreguardian,
    alt: '도와줘요! 포레가디언! 대표 이미지'
  }
];

function CasesSection() {
  return (
    <Section id="cases">
      <div className="cases__container">
        <h2>도입 사례</h2>
        <p className="cases__description">Realworld Studio로 만든 콘텐츠가 운영된 현장이에요.</p>
        <div className="cases">
          {cases.map((item) => (
            <article className="case" key={item.title}>
              <img src={item.image} alt={item.alt} />
              <div className="case__body">
                <h3 className="case__title">{item.title}</h3>
                <p className="case__org">{item.org}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </Section>
  );
}

export default CasesSection;

const Section = styled.section`
  width: 100%;
  padding: 64px 24px;
  box-sizing: border-box;
  background: #fff;

  .cases__container {
    max-width: 1056px;
    margin: 0 auto;
  }
  h2 {
    margin: 0 0 16px;
    font-size: 28px;
    font-weight: 700;
  }
  .cases__description {
    color: #626262;
    font-size: 15px;
  }
  .cases {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(280px, 100%), 1fr));
    gap: 20px;
    margin-top: 32px;
  }
  .case {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    border: 1px solid #ededed;
    border-radius: 16px;
  }
  .case img {
    display: block;
    width: 100%;
    aspect-ratio: 5 / 4;
    object-fit: cover;
    object-position: center;
  }
  .case__body {
    flex: 1;
    padding: 22px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .case__title {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.45;
  }
  .case__org {
    margin: auto 0 0;
    font-size: 15px;
    color: #626262;
  }

  @media (max-width: 768px) {
    padding: 48px 16px;
  }
`;
